import { memo } from 'react'
import { Button } from '@components/ui/button'
import { SectionHeader } from './section-header'

interface PathOperationsProps {
  disabled: boolean
  /** A photo-filled shape's path is its clipping path, so the first button is labelled that way. */
  hasPhotoFill: boolean
  onEditPath?: () => void
  onTextOnPath?: () => void
}

/** Path Operations: Edit Path (Clipping Path for photo fills) and Text on Path. */
function PathOperations({ disabled, hasPhotoFill, onEditPath, onTextOnPath }: PathOperationsProps) {
  return (
    <>
      <SectionHeader>Path Operations</SectionHeader>

      {/* Path Operation Buttons */}
      <div className="space-y-2 pb-4">
        <Button
          variant="ghost"
          size="sm"
          fullWidth
          className="h-9 px-4 py-2 text-sm font-medium leading-normal justify-start"
          disabled={disabled || !onEditPath}
          onClick={onEditPath}
        >
          {hasPhotoFill ? 'Clipping Path' : 'Edit Path'}
        </Button>
        <Button
          variant="ghost"
          size="sm"
          fullWidth
          className="h-9 px-4 py-2 text-sm font-medium leading-normal justify-start"
          disabled={disabled || !onTextOnPath}
          onClick={onTextOnPath}
        >
          Text on Path
        </Button>
      </div>
    </>
  )
}

/** Memoized: the object panel re-renders on every frame of a move, and this section doesn't show position. */
const MemoPathOperations = memo(PathOperations)

export { MemoPathOperations as PathOperations }
